// Photo licence classifier shared by the pool dashboards (Twin Figures, Cities).
//
// Accepted (usable) licences, matching the pipeline's matcher: public domain
// family (PD / CC0 / Public Domain Mark), Creative Commons BY and BY-SA, UK OGL,
// India GODL, Free Art License, and Commons' plain {{Attribution}}. Anything with
// NC/ND, or anything unrecognised, is flagged — the flag bucket means "actually
// unusable". Everything except the public-domain family needs attribution in-app.
export function classifyLicence(lic) {
  const s = (lic || '').toLowerCase().trim()
  if (!s) return { variant: 'danger', short: 'unknown', attrib: false, flag: true }
  // NC (non-commercial) / ND (no-derivatives) are never usable, whatever else it says.
  if (/(^|[-\s])(nc|nd)([-\s]|$)/.test(s)) return { variant: 'danger', short: 'flag', attrib: false, flag: true }
  // Public-domain family — usable, no attribution.
  if (/public domain|^pd|cc0/.test(s)) {
    return { variant: 'success', short: s.startsWith('cc0') ? 'CC0' : (s.startsWith('pdm') ? 'PDM' : 'PD'), attrib: false, flag: false }
  }
  // Usable, attribution required.
  if (/^cc[- ]by[- ]sa\b/.test(s) || s.includes('by-sa') || s.includes('by sa')) return { variant: 'info', short: 'CC BY-SA', attrib: true, flag: false }
  if (/^cc[- ]by\b/.test(s) || s.includes('cc by') || s.includes('cc-by') || s.includes('ccby')) return { variant: 'info', short: 'CC BY', attrib: true, flag: false }
  if (/^ogl\b/.test(s)) return { variant: 'info', short: 'OGL', attrib: true, flag: false }
  if (/^godl/.test(s)) return { variant: 'info', short: 'GODL', attrib: true, flag: false }
  if (/^fal\b/.test(s)) return { variant: 'info', short: 'FAL', attrib: true, flag: false }
  if (/^attribution\b/.test(s)) return { variant: 'info', short: 'Attribution', attrib: true, flag: false }
  return { variant: 'danger', short: 'flag', attrib: false, flag: true }
}
